import axios from 'axios';

const defaultRequestHeaders = {
  'Cache-Control': 'no-cache, no-store, must-revalidate',
  'Pragma': 'no-cache',
  'Expires': '0',
  'Content-Type': 'application/json',
  'Accept': '*/*',
};

function ping(millisToWait, retryConfig) {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API + '/ping',
    timeout: millisToWait,
    headers: {
      ...defaultRequestHeaders,
    },
    'axios-retry': retryConfig ? retryConfig : { },
  });
}

function health(millisToWait) {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API + '/health',
    timeout: millisToWait,
    headers: {
      ...defaultRequestHeaders,
      'Authorization': 'Token token=' + localStorage.token,
    },
  });
}

export default {
  ping,
  health,
};



// WEBPACK FOOTER //
// ./src/services/statusService.js